// The webhook events a merchant can subscribe to, rendered by the integrations
// drawer (src/pages/integrations/components/WebhookSection.jsx) when connecting
// a webhook and when editing one.
//
// Keep this the only copy. The edit form seeds its state from the saved
// config.events and writes the whole array back on save, so an event missing
// from this list stays subscribed and keeps firing while rendering no checkbox.
//
// `value` is the literal event name the backend dispatches (see the
// dispatch_webhook calls in Transaction and Customer); it must match exactly.
export const WEBHOOK_EVENT_OPTIONS = [
  {
    value: "customer.created",
    labelKey: "integrations.webhook.customerCreated",
  },
  {
    value: "customer.updated",
    labelKey: "integrations.webhook.customerUpdated",
  },
  {
    value: "transaction.created",
    labelKey: "integrations.webhook.transactionCreated",
  },
  // A customer the store already has fills the signup form again. Nothing is
  // created and no transaction happens, so none of the events above fire — yet
  // for a store whose customer base arrived by import, that is where much of a
  // campaign's traffic lands, and the click id on that submission appears in
  // this payload and nowhere else.
  {
    value: "customer.signup_attempt",
    labelKey: "integrations.webhook.customerSignupAttempt",
  },
];

// Removed 2026-08-20: `transaction.purchase` and `transaction.redemption`. They
// were a server-side filter over transaction.created, and the payload carries
// `kind`, so a consumer narrows it themselves — `kind === "redeem"` for
// redemptions, and scan/manual/bookingkit/shopify with `point > 0` for sales
// (the sign is what excluded downward manual corrections and BookingKit
// reversals). Nothing outside the test store had subscribed.
//
// Per the note above, an event dropped from this list stays in any saved
// config.events and would keep firing — these two do not, because the backend
// no longer dispatches them at all.
